import { render, staticRenderFns } from "./FormQuestionLabel.vue?vue&type=template&id=7bf85e2a&scoped=true&"
import script from "./FormQuestionLabel.vue?vue&type=script&lang=js&"
export * from "./FormQuestionLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormQuestionLabel.vue?vue&type=style&index=0&id=7bf85e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf85e2a",
  null
  
)

export default component.exports